exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/** Button按钮间距 */\n.ant-btn[data-v-1b51ca48] {\n  margin-left: 3px\n}\n.ant-card[data-v-1b51ca48] {\n  margin-left: -30px;\n  margin-right: -30px;\n}\n.table-page-search-wrapper[data-v-1b51ca48] {\n  margin-top: -16px;\n  margin-bottom: 16px;\n}\n", ""]);

// exports
